/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Location from './Location';
import TravelCost from './TravelCost';
import Trip from './Trip';
import Vehicle from './Vehicle';
import VehicleType from './VehicleType';

/**
 * The ProblemData model module.
 * @module model/ProblemData
 * @version 0.0.2
 */
class ProblemData {
    /**
     * Constructs a new <code>ProblemData</code>.
     * This schema defines the problem data for an optimization Problem. The particular data objects used will depend on the problemType.
     * @alias module:model/ProblemData
     */
    constructor() { 
        
        ProblemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProblemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProblemData} obj Optional instance to populate.
     * @return {module:model/ProblemData} The populated <code>ProblemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProblemData();

            if (data.hasOwnProperty('locations')) {
                obj['locations'] = ApiClient.convertToType(data['locations'], [Location]);
            }
            if (data.hasOwnProperty('trips')) {
                obj['trips'] = ApiClient.convertToType(data['trips'], [Trip]);
            }
            if (data.hasOwnProperty('vehicles')) {
                obj['vehicles'] = ApiClient.convertToType(data['vehicles'], [Vehicle]);
            }
            if (data.hasOwnProperty('vehicleTypes')) {
                obj['vehicleTypes'] = ApiClient.convertToType(data['vehicleTypes'], [VehicleType]);
            }
            if (data.hasOwnProperty('travelCosts')) {
                obj['travelCosts'] = ApiClient.convertToType(data['travelCosts'], [TravelCost]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProblemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProblemData</code>.
     */
    static validateJSON(data) {
        if (data['locations']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['locations'])) {
                throw new Error("Expected the field `locations` to be an array in the JSON data but got " + data['locations']);
            }
            // validate the optional field `locations` (array)
            for (const item of data['locations']) {
                Location.validateJSON(item);
            };
        }
        if (data['trips']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['trips'])) {
                throw new Error("Expected the field `trips` to be an array in the JSON data but got " + data['trips']);
            }
            // validate the optional field `trips` (array)
            for (const item of data['trips']) {
                Trip.validateJSON(item);
            };
        }
        if (data['vehicles']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['vehicles'])) {
                throw new Error("Expected the field `vehicles` to be an array in the JSON data but got " + data['vehicles']);
            }
            // validate the optional field `vehicles` (array)
            for (const item of data['vehicles']) {
                Vehicle.validateJSON(item);
            };
        }
        if (data['vehicleTypes']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['vehicleTypes'])) {
                throw new Error("Expected the field `vehicleTypes` to be an array in the JSON data but got " + data['vehicleTypes']);
            }
            // validate the optional field `vehicleTypes` (array)
            for (const item of data['vehicleTypes']) {
                VehicleType.validateJSON(item);
            };
        }
        if (data['travelCosts']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['travelCosts'])) {
                throw new Error("Expected the field `travelCosts` to be an array in the JSON data but got " + data['travelCosts']);
            }
            // validate the optional field `travelCosts` (array)
            for (const item of data['travelCosts']) {
                TravelCost.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/Location>} locations
 */
ProblemData.prototype['locations'] = undefined;

/**
 * @member {Array.<module:model/Trip>} trips
 */
ProblemData.prototype['trips'] = undefined;

/**
 * @member {Array.<module:model/Vehicle>} vehicles
 */
ProblemData.prototype['vehicles'] = undefined;

/**
 * @member {Array.<module:model/VehicleType>} vehicleTypes
 */
ProblemData.prototype['vehicleTypes'] = undefined;

/**
 * @member {Array.<module:model/TravelCost>} travelCosts
 */
ProblemData.prototype['travelCosts'] = undefined;






export default ProblemData;

